import { render, staticRenderFns } from "./ExportInvoices.vue?vue&type=template&id=0b349db4&"
import script from "./ExportInvoices.vue?vue&type=script&lang=js&"
export * from "./ExportInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports